<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()">
          新增调拨单
        </el-button>
        <el-dropdown class="m-l-10">
          <el-button type="default" size="mini">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="batchDelete">
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
          <span>调拨日期:</span>
          <e-date-picker
            type="daterange"
            :value.sync="bill_date"
            isShowFast
            @change="searchListData"
          />
        </el-form>
        <el-button
          size="mini"
          icon="el-icon-refresh"
          class="m-l-10"
          :disabled="!hasFilter"
          @click="resetFilter"
          >重置筛选
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :show-footer="!!tableData.length"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :footer-method="footerMethod"
      @cell-dblclick="itemDbDo"
      @resizable-change="handleColumnResize"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value="filterData[column.field]"
          placeholder="输入关键字"
          @change="headerFilterChange"
        />
      </template>
      <template #default_bill_no="{ row }">
        <el-link type="primary" @click="itemDo(row.id)">{{ row.bill_no }}</el-link>
      </template>
      <template #default_status_str="{ row }">
        <el-tag :type="statusTagType(row.status)" size="mini" plain>{{ row.status_str }}</el-tag>
      </template>
      <template #default_total_qty="{ row }">
        <span class="c-orange">{{ row.total_qty }}</span>
      </template>
      <template #default_operate="{ row }">
        <el-dropdown>
          <el-button type="default" size="mini">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="canEdit(row)" @click.native="itemDo(row.id)">
              <span class="c-blue">编辑</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="canAudit(row)" @click.native="itemAudit(row)">
              <span class="c-green">审核</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="canUnaudit(row)" @click.native="itemUnaudit(row)">
              <span class="c-blue">反审核</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="canEdit(row)" @click.native="itemCancel(row)">
              <span class="c-gray">作废</span>
            </el-dropdown-item>
            <el-dropdown-item v-if="canEdit(row)" @click.native="itemDelete(row)">
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-新增/编辑调拨单 -->
    <PopupDo v-if="isShowPopupDo" :show.sync="isShowPopupDo" :id="activeId" @success="updatePage" />
  </div>
</template>

<script>
export default {
  tableName: 'new_stock_transfer_list',
  components: {
    PopupDo: () => import('../common/popup-do')
  },
  data() {
    return {
      loading: true,
      bill_date: [],
      filterData: {
        bill_no: '',
        from_warehouse_name: '',
        to_warehouse_name: '',
        status_str: '',
        create_name: ''
      },
      sortData: {
        create_date: 'desc'
      },
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        total_qty_all: ''
      },
      isShowPopupDo: false,
      activeId: null
    }
  },
  computed: {
    hasFilter() {
      return Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
    },
    headerFilterUrl() {
      return '/admin/gcvip/stockTransfer/searchHeard'
    },
    tableColumn() {
      let result = [
        { fixed: 'left', type: 'checkbox', width: 40 },
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        {
          fixed: 'left',
          title: '调拨单号',
          field: 'bill_no',
          slots: { header: 'header_input', default: 'default_bill_no' },
          width: 140
        },
        { title: '调拨日期', field: 'bill_date', slots: { header: 'header_input' }, width: 110 },
        { title: '创建日期', field: 'create_date', slots: { header: 'header_input' }, width: 150 },
        { title: '调出仓库', field: 'from_warehouse_name', slots: { header: 'header_input' }, width: 120 },
        { title: '调入仓库', field: 'to_warehouse_name', slots: { header: 'header_input' }, width: 120 },
        {
          title: '状态',
          field: 'status_str',
          slots: { header: 'header_input', default: 'default_status_str' },
          width: 90
        },
        {
          title: '总数量',
          field: 'total_qty',
          slots: { header: 'header_input', default: 'default_total_qty' },
          width: 90
        },
        { title: '备注', field: 'remark', width: 160 },
        { title: '创建人', field: 'create_name', slots: { header: 'header_input' }, width: 90 },
        { title: '审核人', field: 'auditor_name', slots: { header: 'header_input' }, width: 90 },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    statusTagType(status) {
      // 0草稿 1待审核 2已审核 3作废
      if (status === 2) return 'success'
      if (status === 3) return 'info'
      if (status === 0) return 'info'
      return 'warning'
    },
    canEdit(row) {
      return row.status === 0 || row.status === 1
    },
    canAudit(row) {
      return row.status === 0 || row.status === 1
    },
    canUnaudit(row) {
      return row.status === 2
    },
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    updatePage() {
      this.searchListData()
    },
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    resetFilter() {
      this.resetFilterData()
      this.searchListData()
    },
    resetFilterData() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
    },
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        bill_date: this.bill_date || [],
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/stockTransfer/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = this.$util.deepCopy(data.list) || []
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
            this.totalObj.total_qty_all = res.data.total_qty_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true)
    },
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isChecked = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isChecked)
      }
    },
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'total_qty') return this.totalObj.total_qty_all
        })
      ]
    },
    itemDo(id = null) {
      this.activeId = id
      this.isShowPopupDo = true
    },
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    itemAudit(row) {
      this.$confirm(`确定审核调拨单"${row.bill_no}"吗?审核后将执行调出仓扣减并写入调入仓。`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/stockTransfer/audit',
            params: { id: row.id }
          })
            .then((res) => {
              this.handleActionRes(res, '审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    itemUnaudit(row) {
      this.$confirm(`确定反审核调拨单"${row.bill_no}"吗?将回滚调拨出入库。`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/stockTransfer/unaudit',
            params: { id: row.id }
          })
            .then((res) => {
              this.handleActionRes(res, '反审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    itemCancel(row) {
      this.$confirm(`确定作废调拨单"${row.bill_no}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/stockTransfer/cancel',
            params: { id: row.id }
          })
            .then((res) => {
              this.handleActionRes(res, '作废成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    itemDelete(row) {
      this.$confirm(`确定删除调拨单"${row.bill_no}"吗?`, '提示')
        .then(() => {
          this.deleteConfirm([row.id])
        })
        .catch(() => {})
    },
    batchDelete() {
      let rows = this.getCheckboxRecords()
      if (!rows.length) {
        this.$tool.tableChoosePrompt()
        return
      }
      let uneditable = rows.filter((r) => !this.canEdit(r))
      if (uneditable.length) {
        this.$message.warning('存在已审核/已作废单据，无法删除')
        return
      }
      let ids = [...new Set(rows.map((item) => item.id))]
      this.$confirm(`确定删除选中的 ${ids.length} 条调拨单吗?`, '提示')
        .then(() => {
          this.deleteConfirm(ids)
        })
        .catch(() => {})
    },
    deleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/stockTransfer/delete',
        params: { ids: ids.join(',') }
      })
        .then((res) => {
          this.handleActionRes(res, '删除成功')
        })
        .catch(() => {})
    },
    handleActionRes(res, okMsg) {
      if (res.data.state === 'ok') {
        this.$message.success(res.data.msg || okMsg)
        this.getListData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
